/**
 * @fileoverview Defines HTTP method constants for use in API requests.
 *
 * @constant
 * @namespace Method
 * @description Provides standard HTTP method names as string constants.
 * @property {string} GET    - Represents the HTTP GET method.
 * @property {string} POST   - Represents the HTTP POST method.
 * @property {string} PUT    - Represents the HTTP PUT method.
 * @property {string} DELETE - Represents the HTTP DELETE method.
 * @property {string} PATCH  - Represents the HTTP PATCH method.
 */
export const Method = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};
